import { AuthService } from "../index";

export default function auth({ next, router }) {
  if (!AuthService.check()) {
    return router.push({ name: "login" });
  }
  return next();
}
